import { render, staticRenderFns } from "./UiRadioButton.vue?vue&type=template&id=adf282be&scoped=true&"
import script from "./UiRadioButton.vue?vue&type=script&lang=js&"
export * from "./UiRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./UiRadioButton.vue?vue&type=style&index=0&id=adf282be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf282be",
  null
  
)

export default component.exports